import { render, staticRenderFns } from "./collectionslist-client-suppliers.vue?vue&type=template&id=0b554684&"
import script from "./collectionslist-client-suppliers.vue?vue&type=script&lang=js&"
export * from "./collectionslist-client-suppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports